/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { WebhookConfigurationsArray } from '../../models/webhook-configurations-array';

export interface GetAdministrationOrganizationWebhooks$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
}

export function getAdministrationOrganizationWebhooks(http: HttpClient, rootUrl: string, params: GetAdministrationOrganizationWebhooks$Params, context?: HttpContext): Observable<StrictHttpResponse<WebhookConfigurationsArray>> {
  const rb = new RequestBuilder(rootUrl, getAdministrationOrganizationWebhooks.PATH, 'get');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WebhookConfigurationsArray>;
    })
  );
}

getAdministrationOrganizationWebhooks.PATH = '/administration/organizations/{organizationKey}/webhooks';
